import React from 'react';
import ReactDOM from 'react-dom';
import { useLocation, matchPath, useHistory } from 'react-router-dom';
import { useTheme } from '@nbx/frontend-helpers/subscribe';
import { BottomNavButton } from './BottomNavButton';
import styles from './BottomNav.module.scss';
import classNames from 'classnames';
import { Capacitor } from '@capacitor/core';
import { useTranslation } from 'react-i18next';

export const BottomNavPortal = props => {
  return ReactDOM.createPortal(<BottomNav {...props} />, document.getElementById('sticky_nav_hook'));
};

const tabs = [
  {
    name: 'bottom_nav_home',
    path: '/dashboards',
    icon: 'bottom-nav-home',
    matchOpts: [
      { path: '/', exact: true },
      { path: '/dashboards', exact: false }
    ]
  },
  {
    name: 'bottom_nav_funds',
    path: '/funds',
    icon: 'bottom-nav-funds',
    matchOpts: [
      { path: '/funds', exact: false },
      { path: '/tokenization', exact: false }
    ]
  },
  {
    name: 'bottom_nav_buy_sell',
    path: '/quickbuy',
    icon: 'bottom-nav-buy-sell',
    matchOpts: [{ path: '/quickbuy', exact: false }]
  },
  {
    name: 'bottom_nav_deposit',
    path: '/widget-addfunds',
    icon: 'bottom-nav-deposit',
    matchOpts: [{ path: '/widget-addfunds', exact: false }]
  },
  {
    name: 'bottom_nav_account',
    path: '/account',
    icon: 'bottom-nav-account',
    matchOpts: [
      { path: '/account', exact: false },
      { path: '/verification', exact: false }
    ]
  }
];

export const BottomNav = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = useLocation();
  const theme = useTheme();

  const idx = tabs.findIndex(({ matchOpts }) => matchOpts?.some(opts => matchPath(pathname, opts)));

  return (
    <nbx-theme-provider theme={theme}>
      <div
        className={classNames(styles.bottomNav, {
          [styles.bottomNavIos]: Capacitor.getPlatform() === 'ios'
        })}>
        {tabs.map((tab, i) => (
          <BottomNavButton
            key={tab.path}
            label={t(tab.name)}
            icon={tab.icon}
            onClick={() => {
              history.push(tab.path);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            active={i === idx}
          />
        ))}
        <span
          className={styles.navIndicator}
          style={{
            transform: `translateX(${idx * 100}%)`
          }}></span>
      </div>
    </nbx-theme-provider>
  );
};
